<template>
    <verification-record @uploaded="onUploaded" />
</template>

<script>
import VerificationRecord from "@/components/verification/VerificationRecord";

export default {
    methods: {
        onUploaded(url) {
            this.$store.commit("verification/setRecordingUploading", true);

            this.api
                .post("/userVideo/uploadVerification", {
                    url,
                    code: this.code,
                })
                .then(() => {
                    return this.$store.dispatch("onboarding/status");
                })
                .then(() => {
                    this.$store.commit(
                        "verification/setRecordingUploading",
                        false
                    );
                });
        },
    },
    components: {
        VerificationRecord,
    },
    props: ["code"],
};
</script>
